import type { GetUserSubscriptions200SubscriptionsItem } from './getUserSubscriptions200SubscriptionsItem';

export type GetUserSubscriptions200 = {
  subscriptions: GetUserSubscriptions200SubscriptionsItem[];
  /** 전체 구독 수 */
  totalCount: number;
};
